import { apiGet } from 'ApiPackage/MainModule/common/apiTools';
import { config } from 'CorePackage/MainModule/constants/config';

import { IFilterValue } from '../interfaces/IFilterValue';
import { IKnmPreview } from '../interfaces/IKnmPreview';
import { ISearchResponse } from '../interfaces/ISearchResponse';

export async function getPassportById(id: string, token: string | null): Promise<IKnmPreview> {
  return apiGet<IKnmPreview>(`${config.server}/inspections/${id}`, token);
}

export async function getSearchPasport(params: string, captchaToken: string | null): Promise<ISearchResponse> {
  return apiGet<ISearchResponse>(`${config.server}/inspections/find?${params}`, captchaToken);
}

export async function exportInOds(params: string, captchaToken: string): Promise<Blob> {
  return apiGet<Blob>(`${config.server}/inspections/ods-list?${params}`, captchaToken);
}

export async function exportInXlsx(params: string, captchaToken: string): Promise<Blob> {
  return apiGet<Blob>(`${config.server}/inspections/xlsx-list?${params}`, captchaToken);
}

export async function getPassportPdfById(id: number, captchaToken: string | null): Promise<Blob> {
  return apiGet<Blob>(`${config.server}/inspections/${id}/pdf`, captchaToken);
}

export async function fetchFilterValues(): Promise<IFilterValue[]> {
  return apiGet<IFilterValue[]>(`${config.server}/inspections/filter/all`);
}

export async function getPassportByToken(token: string): Promise<IKnmPreview> {
  return apiGet<IKnmPreview>(`${config.server}/inspections/link-only/${token}`);
}

export async function getDecisionPassportById(id: string, token: string | null): Promise<IKnmPreview> {
  return apiGet<IKnmPreview>(`${config.server}/inspections/decision/${id}`, token);
}

export async function getDecisionPassportByToken(token: string): Promise<IKnmPreview> {
  return apiGet<IKnmPreview>(`${config.server}/inspections/decision/link-only/${token}`);
}

export async function getDecisionPassportPdfById(id: number, captchaToken: string | null): Promise<Blob> {
  return apiGet<Blob>(`${config.server}/inspections/decision/${id}/pdf`, captchaToken);
}
